import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Customer endpoints
  createCustomer: (data) => {
    return AxiosBusiness.post('customer', data)
  },

  updateCustomer: (customerId, data) => {
    return AxiosBusiness.put(`customer/${customerId}`, data)
  },

  deleteCustomer: (customerId) => {
    return AxiosBusiness.delete(`customer/${customerId}`)
  },

  getCustomer: (customerId) => {
    return AxiosBusiness.get(`customer/${customerId}`)
  },

  getAllCustomers: (params) => {
    return AxiosBusiness.get('customer', { params })
  },

  getAllCustomersByTenant: (tenantId, params) => {
    return AxiosBusiness.get(`customer/tenant/${tenantId}`, { params })
  },

  getAllCustomersByCompany: (companyId, params) => {
    return AxiosBusiness.get(`customer/company/${companyId}`, { params })
  },

  getAllCompaniesByCustomer: (customerId, params) => {
    return AxiosBusiness.get(`company/customer/${customerId}`, { params })
  },
}
